/**
 * Production SPA entry, and the only one `ui/index.html` names. It boots the
 * real auth gate unconditionally — the gate-free header-auth boot lives
 * behind its own dev-server-only entry under `ui/src/dev/`, which nothing
 * here imports.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HubBoot } from "./auth/HubBoot";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Hub root element is missing");
}

createRoot(root).render(
  <StrictMode>
    <HubBoot />
  </StrictMode>,
);
